<template>
  <div :class="$style.tokenModeControl">
    <h1 :class="$style.title" v-text="'token mode'" />
    <button
      type="button"
      aria-label="Token mód opciók"
      :class="$style.button"
      @click="openDialog"
    >
      <lv-icon name="hamburger-menu-16" :size="16" />
    </button>
    <dialog ref="dialogElement" :class="$style.dialog">
      <button
        autofocus
        :class="$style.button"
        @click="closeDialog"
      >
        Dialógus bezárása [ESC]
        <lv-icon name="arrow-left-16" :size="16" />
      </button>
      <button
        aria-label="close token mode"
        :class="$style.button"
        @click="closeTokenMode"
      >
        Kilépés a token módból
        <lv-icon name="close-24" :size="16" />
      </button>
      <button
        type="button"
        :aria-pressed="isTokenModeCssEnabled"
        :class="$style.button"
        @click="tokenModeStore.setIsTokenModeCssEnabled(!isTokenModeCssEnabled)"
      >
        Token mód CSS
      </button>
    </dialog>
  </div>
</template>

<script setup>
  import { useRoute } from 'nuxt/app';
  import { useTokenModeStore } from '~~/common/stores/tokenMode';
  import { LvIcon } from '~~/common/components/loginet-vue-shop/index';

  const tokenModeStore = useTokenModeStore();
  const dialogElement = ref(null);
  const isTokenModeCssEnabled = computed(() => tokenModeStore.isTokenModeCssEnabled);

  function openDialog () {
    if (dialogElement.value?.showModal) {
      dialogElement.value.showModal();
    }
  }

  function closeDialog () {
    if (dialogElement.value?.close) {
      dialogElement.value.close();
    }
  }

  function closeTokenMode () {
    const route = useRoute();
    const path = route.path;
    const newQuery = { ...route.query };
    delete newQuery.isInTokenMode;
    const newSearchParams = new URLSearchParams(newQuery);
    window.location.href = `${
      window.location.origin
    }${
      path
    }${
      newSearchParams.size ? '?' : ''
    }${
      newSearchParams
    }`;
  }
</script>

<style module lang="scss" rel="stylesheet/scss">
.tokenModeControl {
  position: fixed;
  z-index: 5;
  bottom: 0;
  display: flex;
  flex-direction: row-reverse;
  color: $color-marigold;
  border: 1px dashed $color-marigold;
  border-top-right-radius: 8px;
  background: rgba(0, 0, 0, 0.7);
}

.title {
  font-weight: bold;
  padding: 0 3px;
}

.button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-radius: 4px;

  &[aria-pressed]::after {
    margin: 0 3px;
    padding: 4px;
    content: "";
    border: 1px solid currentColor;
    background: $color-brand-primary;
  }

  &[aria-pressed="true"]::after {
    background: $color-brand-secondary;
  }
}

.dialog[open] {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: $color-marigold;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.7);
}
</style>
